import React from 'react';
import { Typography, Card } from 'antd';
import AverageTagSmall from '../components/averageTagSmall/averageTagSmall';
import AutoSizeTitle from '../components/autoSizeTitle/AutoSizeTitle';
import LeadershipByOrgItems from '../components/leadershipByOrgItems/leadershipByOrgItems';
import { getEvaluationScoreColor } from '../components/selfcare360/selfcare360Scales';

const { Title, Text } = Typography;

const PageResultsByOrgItems = ({
    selectedEvaluation,
    average,
    item,
    pageNumber,
    chartData = [],
    isFirstPage = false,
}) => {
    const backgroundStyle = {
        backgroundImage: `url('/informs/pagina.png')`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left top',
        backgroundSize: '100% auto',
    };

    const getColor = (value) => getEvaluationScoreColor(value, {
        redLight: selectedEvaluation.evl_max_red_light,
        yellowLight: selectedEvaluation.evl_max_yellow_light,
        serviceId: selectedEvaluation?.evl_srv_id,
    });

    return (
        <div className="pdf-page internal-page">
            <div className="internal-page-content" style={backgroundStyle}>
                <AutoSizeTitle text={selectedEvaluation.evl_title} />

                <div className="internal-page-info" style={{ position: "relative" }}>
                    <AverageTagSmall
                        average={average}
                        color={getColor(average)}
                        type={1}
                    />

                    <Card
                        style={{
                            borderRadius: '8px',
                            border: '1px solid #d9d9d9',
                            backgroundColor: '#fafafaff',
                            boxShadow: 'none',
                        }}
                        styles={{ body: { padding: '16px 24px' } }}
                    >
                        <Title level={4} style={{ color: '#339C98', marginBottom: 16, width: 'calc(100% - 150px)' }}>
                            {item.title}
                        </Title>

                        <LeadershipByOrgItems
                            subtitle={item.subtitle}
                            singularSubtitle={item.singularSubtitle}
                            chartData={chartData}
                            redLight={selectedEvaluation.evl_max_red_light}
                            yellowLight={selectedEvaluation.evl_max_yellow_light}
                            serviceId={selectedEvaluation?.evl_srv_id}
                            isFirstPage={isFirstPage}
                        />
                    </Card>
                </div>

                <div className="internal-page-number">{pageNumber}</div>
            </div>
        </div>
    );
};

export default PageResultsByOrgItems;
